<form [formGroup]="filterForms" (ngSubmit)="checkAndCallMethods()">
    @if (localTableFilters) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Filter</mat-label>
        <mat-select formControlName="tableFilter">
            @for (filter of localTableFilters; track filter) {
            <mat-option [value]="filter">
                {{filter.displayName}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }
    @if (filterForms.get('tableFilter')?.value) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>{{filterForms.value.tableFilter.displayName || ''}}</mat-label>

        @if (isArray() && filterForms.value.tableFilter.displayName !== 'Work Order Type') {
        <mat-select formControlName="value" (selectionChange)="changeValue($event.value)">
            @for (val of filterForms.value.tableFilter.values; track val) {
            <mat-option [value]="val">
                {{val}}
            </mat-option>
            }
        </mat-select>
        } @else {
        <label>
            @if (filterForms.value.tableFilter.displayName !== 'Work Order Type') {
            <input matInput placeholder="{{filterForms.value.tableFilter.displayName || ''}}" formControlName="value">
            }
        </label>
        }

        @if (filterForms.value.tableFilter.displayName === 'Work Order Type') {
        <mat-select formControlName="value">
            @for (workOrder of workOrders; track workOrder) {
            @if (us == true || asia == true) {
            <mat-option [value]="workOrder">
                {{workOrder}}
            </mat-option>
            }
            }
            @for (workOrder of workOrdersUk; track workOrder) {
            @if (europe == true) {
            <mat-option [value]="workOrder">
                {{workOrder}}
            </mat-option>
            }
            }
        </mat-select>
        }
    </mat-form-field>
    }

    <!-- @if (dateFilterSelected) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Choose date range</mat-label>
        <input matInput type="text" bsDaterangepicker [bsConfig]="bsConfig" [minDate]="todayDate || undefined"
            [maxDate]="maxDate" [(ngModel)]="bsRangeValue" [ngModelOptions]="{standalone: true}">
    </mat-form-field> 
    } -->
    @if (dateFilterSelected) {
        <mat-form-field subscriptSizing="dynamic" class="filter">
            <mat-label>{{ filterForms.value.value || currentDisplayName || 'Choose date range' }}</mat-label>
            <input matInput type="text" bsDaterangepicker [bsConfig]="bsConfig"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [(ngModel)]="bsRangeValue" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
    }

    <div class="buttons">
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="isFilterSet()"
            (click)="isAddFilterCliecked()">Add</button>
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isWONumberFilterApplied()"
            (click)="isSearchClicked()">Search</button>
        <button mat-stroked-button class="button" [disabled]="!isAnyFilterSet()" (click)="reset()">Reset</button>
    </div>
</form>

@if (filterAdded) {
<div class="chips">
    <mat-chip-set class="example-chip-list" aria-label="Filter selection">
        @for (filters of filterArray; track filters) {
        <mat-chip (removed)="remove(filters.column)">
            {{filters.dispalyName}} - {{filters.value}}
            @if (removable) {
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
            }
        </mat-chip>
        }
    </mat-chip-set>
</div>
}

@if (isLoadingResults) {
<div class="loading-shade">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
</div>
}